import type { MouseEvent, ReactElement } from "react";

import I18n from "app/pages/sales-intelligence/common-components/i18n/I18n";
import type { Translatable } from "app/pages/sales-intelligence/types";

import { FIND_APPS_BUTTON_SIZE } from "../../constants";

import { StyledFiltersPanelClearButton } from "./styles";

const DEFAULT_LABEL = { key: "common.clear" };

interface IProps {
    label?: Translatable;
    onClick?(e: MouseEvent<HTMLSpanElement>): void;
}

export const FilterItemClearButton = ({ label = DEFAULT_LABEL, onClick }: IProps): ReactElement => {
    const handleClick = (e: MouseEvent<HTMLSpanElement>): void => {
        e.stopPropagation();

        onClick?.(e);
    };

    return (
        <I18n
            translatable={label}
            element={StyledFiltersPanelClearButton}
            type="flat"
            height={FIND_APPS_BUTTON_SIZE}
            onClick={handleClick}
        />
    );
};
